module.exports = __webpack_public_path__ + "img/7.d77bfc57.png";